import { mapState, mapActions } from 'vuex'

// 任意のサービスに登録された配信タイプから選択するUIモジュール
// ●使用箇所
// 「サービス管理-コンテンツ設定-コンテンツ基本設定」
// 「サービス管理-コンテンツ設定-画面別設定-画面別コンテンツ編集」
export default {
  name: 'ServiceDeliveryTypeSelectorButton',
  props: {
    name: {
      type: String,
      require: true
    },
    serviceId: {
      type: String,
      require: true
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: Array,
      require: false,
      'default': () => []
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    }
  },
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectServiceDeliveryTypeModal.buttonId,
      modalIndex: state => state.selectServiceDeliveryTypeModal.index,
      value: state => state.selectServiceDeliveryTypeModal.value,

      // model
      serviceDeliveryTypeModel: state => state.selectServiceDeliveryTypeModal.serviceDeliveryTypeModel,
    }),

    results () {
      if (this.loading) return ''

      // 配信タイプ名を取得
      try {
        return this.serviceDeliveryTypeModel
          .filter(item => this.model.indexOf(item.deliveryType) !== -1)
          .map(item => item.deliveryTypeName).join('、')
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },

    // showDeleteButton () {
    //   return this.model ? true : false
    // }
  },
  watch: {
    value (to) {
      console.log('@@', this.index, to)
      // 1画面に複数のモジュールが設置された場合の識別処理
      if (to &&
        this.buttonId === this.name &&
        this.index === this.modalIndex) {
        // console.log(this.name, to)
        this.changeValue(to)
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      loadModel: 'selectServiceDeliveryTypeModal/loadModel',
      showModal: 'selectServiceDeliveryTypeModal/show',
      setValue: 'selectServiceDeliveryTypeModal/setValue'
    }),

    init () {
      // 初期データを格納
      // this.setValue($.extend(true, [], this.model))

      // RSS取得のためデータ読出
      this.loading = true

      //
      let serviceDeliveryTypeParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        serviceDeliveryTypeParams: serviceDeliveryTypeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    showSelector () {
      this.showModal({
        serviceId: this.serviceId,
        buttonId: this.name,
        index: this.index,
        data: $.extend(true, [], this.model)
      })
    },

    changeValue (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    },
    // deleteScreen () {
    //   this.$emit('childs-delete', {
    //     name: this.name,
    //     index: this.index
    //   })
    // }
  }
}